// frontend/src/components/Navbar.jsx

import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import SinoNotificacoes from './SinoNotificacoes';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const { isAdmin, isFisioterapeuta, isPaciente, user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
  };

  const handlePerfilClick = () => {
    if (isPaciente) navigate('/meu-painel');
    else navigate('/perfil');
  };

  return (
    <>
      <header className="bg-gray-800 text-white shadow-md">
        <div className="container mx-auto px-4 py-3 flex items-center justify-between">
          <div className="flex items-center">
            <button onClick={() => setIsOpen(!isOpen)} className="mr-4">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 12h16"></path></svg>
            </button>
            <img src="/logo.png" alt="FisioWeb" className="h-10 w-auto" />
          </div>

          {/* Clique no perfil navega para /perfil */}
          <div className="flex items-center gap-2">
            {isFisioterapeuta && <SinoNotificacoes />}
            <div
              className="flex items-center cursor-pointer hover:opacity-80 transition-opacity"
              onClick={handlePerfilClick}
              title="Meu Perfil"
            >
              <span className="hidden sm:block mr-2 text-sm">{user?.nome || 'Perfil'}</span>
              <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
            </div>
          </div>
        </div>
      </header>

      <aside className={`bg-gray-700 text-white w-64 min-h-screen p-4 fixed top-0 left-0 transform ${isOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300 ease-in-out z-30 flex flex-col`}>

        <div className="flex-shrink-0">
          <div className="flex justify-between items-center mb-6">
            <h2 className="font-bold text-2xl">Menu</h2>
            <button onClick={() => setIsOpen(false)} className="text-white hover:text-gray-300">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
            </button>
          </div>
        </div>

        <nav className="flex-grow overflow-y-auto">
          <ul>
            {isAdmin && (
              <li className="mb-3"><Link to="/admin" className="block p-2 rounded hover:bg-indigo-600" onClick={() => setIsOpen(false)}>Painel Admin</Link></li>
            )}
            {(isFisioterapeuta || isAdmin) && (
              <>
                <li className="mb-3"><Link to="/dashboard" className="block p-2 rounded hover:bg-indigo-600" onClick={() => setIsOpen(false)}>Painel do Paciente</Link></li>
                <li className="mb-3"><Link to="/cadastro" className="block p-2 rounded hover:bg-indigo-600" onClick={() => setIsOpen(false)}>Cadastrar Paciente</Link></li>
                <li className="mb-3"><Link to="/avaliacao" className="block p-2 rounded hover:bg-indigo-600" onClick={() => setIsOpen(false)}>Ficha de Avaliação</Link></li>
                <li className="mb-3"><Link to="/calendario" className="block p-2 rounded hover:bg-indigo-600" onClick={() => setIsOpen(false)}>Calendário</Link></li>
                <li className="mb-3"><Link to="/documentos" className="block p-2 rounded hover:bg-indigo-600" onClick={() => setIsOpen(false)}>Documentos</Link></li>
                <li className="mb-3"><Link to="/financeiro" className="block p-2 rounded hover:bg-indigo-600" onClick={() => setIsOpen(false)}>Financeiro</Link></li>
              </>
            )}
            {isPaciente && (
              <>
                <li className="mb-3"><Link to="/meu-painel" className="block p-2 rounded hover:bg-indigo-600" onClick={() => setIsOpen(false)}>Meu Painel</Link></li>
                <li className="mb-3"><Link to="/meu-calendario" className="block p-2 rounded hover:bg-indigo-600" onClick={() => setIsOpen(false)}>Meu Calendário</Link></li>
              </>
            )}
          </ul>
        </nav>

        <div className="mt-auto flex-shrink-0">
          <div className="border-t border-gray-600 pt-4">
            {/* Clique no nome/ícone do menu lateral também vai para perfil */}
            <div
              className="flex items-center mb-4 cursor-pointer hover:opacity-80 transition-opacity"
              onClick={() => { setIsOpen(false); isPaciente ? navigate('/meu-painel') : navigate('/perfil'); }}
            >
              <svg className="w-8 h-8 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
              <span className="font-medium">{user?.nome || 'Carregando...'}</span>
            </div>
            <button
              onClick={handleLogout}
              className="w-full text-left flex items-center bg-red-500 hover:bg-red-600 text-white p-2 rounded-md text-sm font-medium"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path></svg>
              Sair
            </button>
          </div>
        </div>
      </aside>

      {isOpen && <div className="fixed inset-0 bg-black opacity-50 z-20" onClick={() => setIsOpen(false)}></div>}
    </>
  );
}